import React from 'react';
import PropTypes from 'prop-types';
import Cookies from '../../util/cookies';

class AmplitudeEventLogger extends React.Component {

	constructor(props) {
		super(props);
	}

	handleEvent(eventName, eventData, options) {

		if (!window.amplitude || !options || !options.amplitude) {
			return false;
		}

		const amplitude = window.amplitude.getInstance();
		const eventProperties = {};

		if (eventData) {
			for (var key in eventData) {
				if (eventData.hasOwnProperty(key)) {
					eventProperties[key] = eventData[key];
				}
			}
		}

		if (this.props.AB) {
			eventProperties['ab_data'] = {
				uuid: this.props.AB.uuid,
				varients: this.props.AB.varients
			}
		}

		if (eventName === 'donation') {
			var revenue = new window.amplitude.Revenue().setProductId(eventProperties.productId.toString()).
				setPrice(eventProperties.amount / eventProperties.quantity).
				setQuantity(eventProperties.quantity).setRevenueType(eventProperties.paymentType);

			amplitude.logRevenueV2(revenue);
		}

		const prefix = (options.pageType || this.props.pageType || 'unknown').toUpperCase() + '-';

		amplitude.logEvent(prefix + eventName, eventProperties);

		return true;
	}

	// This component has no state!
	shouldComponentUpdate() {
		return false;
	}

	componentDidMount() {
		const analyticsConfig = this.props.tenantConfig.analytics;
		if (!(analyticsConfig && analyticsConfig.amplitude &&  analyticsConfig.amplitude.enabled)) {
			// Disabled. Do nothing.
			return;
		}

		if (window.eventDispatcher) {
			window.eventDispatcher.addEventHandler(this);

			let self = this;

			if (window.addEventListener) {
				window.addEventListener('load', function () {
					self.enableAmplitudeLogging();
				}, false);
			}
			else if (window.attachEvent) {
				window.attachEvent('onload', function () {
					self.enableAmplitudeLogging();
				});
			}
		}
	}

	componentWillUnmount() {
		window.eventDispatcher.removeEventHandler(this);
	}

	enableAmplitudeLogging() {

		if (window.amplitude) {
			return;
		}

		const analyticsConfig = this.props.tenantConfig.analytics;
		const amplitudePublicKey = analyticsConfig.amplitude.amplitudePublicKey;

		const html = `(function(e,t){var n=e.amplitude||{_q:[],_iq:{}};var r=t.createElement("script")
  ;r.type="text/javascript";r.async=true
  ;r.src="https://cdn.amplitude.com/libs/amplitude-4.5.2-min.gz.js"
  ;r.onload=function(){if(e.amplitude.runQueuedFunctions){
  e.amplitude.runQueuedFunctions()}else{
  console.log("[Amplitude] Error: could not load SDK")}}
  ;var i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)
  ;function s(e,t){e.prototype[t]=function(){
  this._q.push([t].concat(Array.prototype.slice.call(arguments,0)));return this}}
  var o=function(){this._q=[];return this}
  ;var a=["add","append","clearAll","prepend","set","setOnce","unset"]
  ;for(var u=0;u<a.length;u++){s(o,a[u])}n.Identify=o;var c=function(){this._q=[]
  ;return this}
  ;var l=["setProductId","setQuantity","setPrice","setRevenueType","setEventProperties"]
  ;for(var p=0;p<l.length;p++){s(c,l[p])}n.Revenue=c
  ;var d=["init","logEvent","logRevenue","setUserId","setUserProperties","setOptOut",
  "setVersionName","setDomain","setDeviceId","setGlobalUserProperties","identify",
  "clearUserProperties","setGroup","logRevenueV2","regenerateDeviceId","logEventWithTimestamp",
  "logEventWithGroups","setSessionId","resetSessionId"]
  ;function v(e){function t(t){e[t]=function(){
  e._q.push([t].concat(Array.prototype.slice.call(arguments,0)))}}
  for(var n=0;n<d.length;n++){t(d[n])}}v(n);n.getInstance=function(e){
  e=(!e||e.length===0?"$default_instance":e).toLowerCase()
  ;if(!n._iq.hasOwnProperty(e)){n._iq[e]={_q:[]};v(n._iq[e])}return n._iq[e]}
  ;e.amplitude=n})(window,document);

  window.amplitude.getInstance().init('${amplitudePublicKey}', null, {
    includeGclid: true,
    includeReferrer: true,
    includeUtm: true,
    saveEvents: true,
    saveParamsReferrerOncePerSession: false
  });`;

		let self = this;

		setTimeout(function () {
			let script = document.createElement('script');
			script.type = 'text/javascript';
			script.text = html;

			document.body.appendChild(script);
			self.recordPageLoadEvent();
		}, 16);
	}

	recordPageLoadEvent() {
		let url = window.location.href;

		const queryIndex = url.indexOf('?');
		if (queryIndex > -1) {
			url = url.substring(0, queryIndex);
		}

		const eventInfo = {
			prevPage: window.document.referrer,
			url,
		};

		if (window.amplitude) {
			const amplitude = window.amplitude.getInstance();

			try {
				const cookieName = 'amplitude_company_set';
				const userCompanySet = Cookies.read(cookieName);

				if (!userCompanySet && this.props.tenantConfig && this.props.tenantConfig.name) {
					amplitude.setUserProperties({company: this.props.tenantConfig.name.long});
				}
				Cookies.save(cookieName, "true");
			} catch (e) {
				// Nothing?
			}

			try {
				const socialLoginMethodCookieName = 'amplitude_social_login_method';
				const socialLoginSuccessCookieName = 'amplitude_social_login_success';
				const method = Cookies.read(socialLoginMethodCookieName);

				if (method) {
					let eventName = 'loginFailed';
					if (Cookies.read(socialLoginSuccessCookieName) === 'true') {
						eventName = 'loginSuccess'
					}

					Cookies.delete(socialLoginMethodCookieName);
					Cookies.delete(socialLoginSuccessCookieName);

					this.handleEvent(eventName, {method: method}, {amplitude: true});
				}
			}
			catch (e) {
				// Nothing?
			}
		}

		this.addAdditionalPageLoadEventData(eventInfo);
		this.handleEvent('pageLoadEvent', eventInfo, {amplitude: true});
	}

	addAdditionalPageLoadEventData(eventInfo) {
		let data = this.props.data;

		if (this.props.pageType === 'checkout' && data && data.program) {
			data = data.program;
		}

		if (this.props.pageType === 'checkout' && data && data.campaign) {
			data = data.campaign;
		}

		if (this.props.amount) {
			eventInfo.amount = this.props.amount;
		}

		// from programs
		if (data && data.programID) {
			eventInfo.productId = data.programID;
			eventInfo.productTypeId = 1;
			eventInfo.productName = data.programTitle;
			eventInfo.programType = data.programType;
			eventInfo.category = data.cause;
		}
		// from campaigns
		else if (data && data.id) {
			eventInfo.productId = data.id;
			eventInfo.productTypeId = 2;
			eventInfo.productName = data.name;
			eventInfo.programType = 'campaign';
			eventInfo.category = data.cause;
		}
	}

	render() {
		return null;
	}
}

AmplitudeEventLogger.propTypes = {
	pageType: PropTypes.string.isRequired,
	tenantConfig: PropTypes.object.isRequired,
	AB: PropTypes.object,
	data: PropTypes.object,
	amount: PropTypes.number
};

export default AmplitudeEventLogger;
